<template>
  <section class="draw-menu">
    <div class="menu-list" v-if="isMenuVisible">
      <div class="title">INDEX</div>
      <router-link
        class="menu-item"
        v-for="(menu, index) in drowMenuList.menuList"
        :to="`/${drowMenuList.root}#${menu.key}`"
        :key="index"
      >
        {{ menu.name }}
      </router-link>
    </div>
    <div class="menu-bar" @click="showMenu">
      <img :src="drawBarText[isMenuVisible].imgSrc" />
      <div class="bar-title" v-html="drawBarText[isMenuVisible].text"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DrawMenu",
  data() {
    return {
      isMenuVisible: false,
      drawBarText: {
        [true]: {
          imgSrc: require("../assets/img/developers/close-index.svg"),
          text: "CLOSE"
        },
        [false]: {
          imgSrc: require("../assets/img/developers/open-index.svg"),
          text: "INDEX"
        }
      }
    };
  },
  computed: {},
  props: {
    drowMenuList: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    showMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    }
  }
};
</script>

<style scoped lang="scss">
.draw-menu {
  position: fixed;
  border-top-right-radius: 2.5rem;
  border-bottom-right-radius: 2.5rem;
  background-color: colors(dark);
  display: flex;
  align-items: center;
  z-index: 10;

  .menu-list {
    display: flex;
    flex-direction: column;
    height: 28.9375rem;
    width: 20.625rem;
    justify-content: center;
    border-right: solid 0.125rem colors(theme);
    padding-left: 2.5rem;

    .title {
      @include fontSize(large);

      font-weight: bold;
      color: colors(light);
    }

    .menu-item {
      @include fontSize(medium);

      display: flex;
      flex-direction: row;
      align-items: center;
      line-height: 2.6875rem;
      color: colors(light);
      text-decoration: underline;
    }

    .menu-item::before {
      content: "";
      width: 0.875rem;
      height: 0.875rem;
      background: url("../assets/img/shadowbg/shape-interrupt.svg");
      background-size: cover;
      margin-right: 1rem;
    }
  }

  .menu-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 4.375rem;
    height: 28.9375rem;

    .bar-title {
      @include fontSize(base);

      transform: rotate(-90deg);
      font-weight: bold;
      color: colors(light);
      width: 4.25rem;
      justify-content: center;
    }

    img {
      width: 0.9375rem;
      height: auto;
      margin-bottom: 2.25rem;
    }
  }
}
</style>
